import styled from 'styled-components';

import { useTranslation } from 'react-i18next';
import { ColorBeauty5, Spacing2, Spacing4, Spacing16, Spacing20 } from 'autogen/design-tokens/tokens';
import { Body, Heading3 } from 'components/__deprecated/typography';
import { breakpoint, sizes } from 'variables';
import { ButtonWithSpinner } from 'components/Button';
import { openSamplesModal } from 'components/samples/components/samplesPicker';
import isClient from 'helpers/isClient';
import useIsAuthenticated from 'hooks/user/useIsAuthenticated';
import { useOpenLoginQuickView } from 'components/login/shared/hooks/useLoginInfoQuickView';
import {
    Paragraph as ParagraphTrans,
    Headline as HeadlineTrans,
    Button as ButtonTrans
} from 'autogen/translation-keys/trans-website-basket-samples-entrance';
import type { BasketDetailedSamplesViewModel } from 'autogen/swagger/all';
import SingleSampleSelection from '../SingleSampleSelection/SingleSampleSelection';

const SampleBasketEntrance = styled.li`
    display: block;
    list-style: none;
    background-color: ${ColorBeauty5};
    padding: ${Spacing16};

    ${breakpoint.up(sizes.md)} {
        display: flex;
        padding: ${Spacing20};
        align-items: center;
    }
`;

const Text = styled.div`
    margin-bottom: ${Spacing16};
    text-align: center;

    ${breakpoint.up(sizes.md)} {
        flex: 1 0 auto;
        margin-bottom: 0;
        margin-right: ${Spacing16};
        text-align: left;
    }
`;

const Headline = styled(Heading3)`
    margin-top: 0;
    margin-bottom: ${Spacing2};

    ${breakpoint.up(sizes.md)} {
        margin-bottom: ${Spacing4};
    }
`;

const Paragraph = styled(Body)`
    margin-bottom: 0;
`;

const Button = styled(ButtonWithSpinner)`
    width: 100%;
    white-space: nowrap;
    flex: 0;
`;

function MultiSampleSelection() {
    const isAuthenticated = useIsAuthenticated();
    const { t } = useTranslation();
    const openLoginQuickView = useOpenLoginQuickView({
        infoType: 'BasketSample',
        level: 'Hard',
        mode: 'Standard',
        returnUrl: isClient ? `${window.location.pathname}?openSamples=True` : '/'
    });

    return (
        <SampleBasketEntrance>
            <Text>
                <Headline>{t(HeadlineTrans)}</Headline>
                <Paragraph size="sm">{t(ParagraphTrans)}</Paragraph>
            </Text>
            <Button
                size="lg"
                onClick={async () => {
                    if (isAuthenticated) {
                        await openSamplesModal(t(ButtonTrans));
                    } else {
                        await openLoginQuickView();
                    }
                }}
            >
                {t(ButtonTrans)}
            </Button>
        </SampleBasketEntrance>
    );
}

export default function Entrance({ model }: { model?: BasketDetailedSamplesViewModel }) {
    if (model?.hasOnlyOneSample) {
        return <SingleSampleSelection model={model} />;
    }

    return <MultiSampleSelection />;
}
